import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {t} from 'react-switch-lang';

import FindingsTable from '../table/FindingsTable';
import Badge from 'react-bootstrap/Badge';
import RevisionsFilter from '../revisionsFilter/RevisionsFilter';
import {format} from 'date-fns';
import {useUserContext} from '../../../../contexts/UserContext';
import {useDepartmentContext} from '../../../../contexts/DepartmentContext';
import {Link, useHistory, useParams} from 'react-router-dom';
import BackBtn from '../../../RiskComponents/pageHeader/img/arrow-left.svg';
import {
  findingsFilter,
  getRevisionSubTableColumns,
} from '../../const';
import Prompt from '../../../../components/prompt/prompt';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {deleteFinding} from '../../../../services/findings';
import FindingsFilter from '../findingsFilter/FindingsFilter';
import roles from '../../../../utils/roles';

const Findings = () => {
  const [query, setQuery] = useState('');
  const [updateTable, setUpdateTable] = useState(0);
  const [allowCRUD, setAllowCRUD] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const user = useUserContext();
  const departments = useDepartmentContext();
  const history = useHistory();
  const params = useParams();

  const onFindingsDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteFinding'),
        text: t('question.deleteFinding'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteFinding(record?.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {
                  entity: t('revisions.finding'),
                }),
                icon: 'success',
              });
              resolve(response);
              setUpdateTable((prevState) => prevState +1);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const columns = getRevisionSubTableColumns(
    history,
    onFindingsDelete,
    allowCRUD,
    true,
    allowEdit
  );

  const filterSubmit = (data) => {
    const params = findingsFilter(data);
    setQuery(params);
  };

  const revisionRoles = [
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_super_admin,
    roles.role_admin
  ];
  const allowedRoles = [
    roles.role_super_admin,
    roles.role_admin
  ];

  useEffect(() => {
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowEdit(result.length > 0);
  }, [user]);
  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCRUD(result.length > 0);
  }, [user]);

  return (
    <>
      <div className="mx-5">
        <Row>
          <Col xs="12" lg="12" className="mt-4">
            <Link
              to={window.location.pathname}
              className="return-btn-revisions d-flex "
              onClick={() => history.go(-1)}
            >
              <img src={BackBtn} alt="icon" />
              <span>{t('revisions.findingsList')}</span>
            </Link>
            {allowCRUD && (
              <div className=" col-padding d-flex justify-content-end">
                <button
                  onClick={() =>
                    history.push(`/revisions/${params?.id}/findings/add`)
                  }
                  type="button"
                  className="primary-btn mr-2"
                >
                  <img
                    src={process.env.PUBLIC_URL + '/images/whitePlus.svg'}
                    alt={'plusImg'}
                  />

                  <div className="ml-2">{t('buttons.addFinding')}</div>
                </button>
              </div>
            )}
          </Col>
        </Row>
        <FindingsFilter
          submit={filterSubmit}
          user={user}
          departments={departments}
        />
        <FindingsTable
          key={updateTable}
          columns={columns}
          query={query}
          api={'/findings'}
          revisionId={params?.id}
          onClickRow={(findingId, revisionId) => {
            history.push(`/revisions/${revisionId}/findings/${findingId}`);
          }}
        />
      </div>
    </>
  );
};

export default Findings;
